import { reduxForm } from 'redux-form'
import FormWrapper from 'shared/components/form-wrapper'
import { ApiTokenFormValues, ApiTokenFormWrapperProps } from './ApiTokenForm.types'
import { ApiTokenFormAdapter } from './ApiTokenForm.constants'
import validate from './ApiTokenForm.validate'

export default reduxForm<ApiTokenFormValues, ApiTokenFormWrapperProps>({
  form: ApiTokenFormAdapter.name,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(FormWrapper)
